// extracted by mini-css-extract-plugin
export default {"ellipsis":"yy7N0WF8KaRifchnLBig","wrapper":"SwhnCOisLtZ5WhJsOckA","list":"lMHBuKakg6BoYCTDaFTC","listItem":"CkC1egJJIjw2x3yF_kR9","spin":"P0drwDGcCDRzG_LJKZx4"};